import { toast } from 'sonner';

const normalizeMessage = (message) => {
  if (typeof message === 'string') return message;
  try {
    return JSON.stringify(message);
  } catch {
    return String(message);
  }
};

export const showAlertToast = (message) => {
  const text = normalizeMessage(message);
  const lower = text.toLowerCase();
  const successKeywords = ['success', 'approved', 'created', 'uploaded', 'completed', 'submitted', 'granted', 'updated'];
  const errorKeywords = ['error', 'fail', 'failed', 'invalid', 'unable', 'please', 'missing', 'required', 'denied', 'blocked', 'not '];

  const isSuccess = successKeywords.some((k) => lower.includes(k));
  const isError = errorKeywords.some((k) => lower.includes(k));

  if (isSuccess) {
    return toast.success(text);
  }
  if (isError) {
    return toast.error(text);
  }
  return toast(text);
};

export const setupSonnerDialogs = () => {
  if (typeof window === 'undefined') return;
  window.alert = (msg) => {
    showAlertToast(msg);
  };
};

export const confirmToast = (message, options = {}) =>
  new Promise((resolve) => {
    const {
      description,
      confirmLabel = 'Confirm',
      cancelLabel = 'Cancel',
      intent = 'primary'
    } = options;

    const confirmClasses =
      intent === 'danger'
        ? 'bg-red-600 text-white hover:bg-red-700 focus:ring-red-500'
        : 'bg-blue-600 text-white hover:bg-blue-700 focus:ring-blue-500';

    const id = toast.custom((t) => (
      <div className="w-full max-w-sm rounded-md border border-gray-200 bg-white p-4 shadow-lg">
        <p className="text-sm font-medium text-gray-900">{message}</p>
        {description ? <p className="mt-1 text-xs text-gray-600">{description}</p> : null}
        <div className="mt-3 flex items-center justify-end gap-2">
          <button
            type="button"
            className="rounded-md border border-gray-200 px-3 py-1.5 text-sm text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-300"
            onClick={() => {
              toast.dismiss(t.id);
              resolve(false);
            }}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            className={`rounded-md px-3 py-1.5 text-sm focus:outline-none focus:ring-2 ${confirmClasses}`}
            onClick={() => {
              toast.dismiss(t.id);
              resolve(true);
            }}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    ), { duration: Infinity, id: `confirm-${Date.now()}-${Math.random()}` });

    return id;
  });

export const promptToast = (message, options = {}) =>
  new Promise((resolve) => {
    const {
      defaultValue = '',
      placeholder = 'Enter a value',
      confirmLabel = 'Submit',
      cancelLabel = 'Cancel'
    } = options;

    let currentValue = defaultValue;

    const id = toast.custom((t) => (
      <div className="w-full max-w-sm rounded-md border border-gray-200 bg-white p-4 shadow-lg">
        <p className="text-sm font-medium text-gray-900">{message}</p>
        <input
          autoFocus
          defaultValue={defaultValue}
          placeholder={placeholder}
          className="mt-2 w-full rounded-md border border-gray-200 px-3 py-2 text-sm text-gray-900 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-300"
          onChange={(e) => { currentValue = e.target.value; }}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              toast.dismiss(t.id);
              resolve(currentValue);
            }
          }}
        />
        <div className="mt-3 flex items-center justify-end gap-2">
          <button
            type="button"
            className="rounded-md border border-gray-200 px-3 py-1.5 text-sm text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-300"
            onClick={() => {
              toast.dismiss(t.id);
              resolve(null);
            }}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            className="rounded-md bg-blue-600 px-3 py-1.5 text-sm text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
            onClick={() => {
              toast.dismiss(t.id);
              resolve(currentValue);
            }}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    ), { duration: Infinity, id: `prompt-${Date.now()}-${Math.random()}` });

    return id;
  });
